import React, { useState, useEffect } from 'react'
import EVProductCard from './EVProductCard'
import { fetchServiceTiers, ServiceTier } from '../services/drupal'
import './EVProducts.css'

const fallbackTiers: ServiceTier[] = [
  {
    id: 1,
    tierName: 'Elite Ride',
    description: 'A premium point-to-point luxury chauffeur experience in a stylish VW Kombi. Comfortable, discreet, on-time rides wherever you need to be.',
    features: [
      'Professional chauffeur',
      'Luxury seating and finishes',
      'Complimentary bottled water'
    ],
    imageSrc: '/experience/VWKombi1.webp'
  },
  {
    id: 2,
    tierName: 'Concierge Companion',
    description: 'Your chauffeur stays available throughout the day—suggesting hotspots, guiding your journey, and helping with itinerary planning.',
    features: [
      'Dedicated on-call chauffeur',
      'Local guidance and recommendations',
      'Premium refreshments onboard'
    ],
    imageSrc: '/experience/VWKombi2.jpg'
  },
  {
    id: 3,
    tierName: 'VIP Celebrity Experience',
    description: 'Chauffeur acts as a private assistant—shopping help, protection, red-carpet-style treatment. Ultimate luxury on the move.',
    features: [
      'Personal shopping assistant',
      'Bodyguard-style presence',
      'In-vehicle entertainment + luxury amenities'
    ],
    imageSrc: '/experience/VWKombi3.jpg'
  }
]

const EVProducts: React.FC = () => {
  const [serviceTiers, setServiceTiers] = useState<ServiceTier[]>(fallbackTiers)

  useEffect(() => {
    fetchServiceTiers()
      .then(setServiceTiers)
      .catch(() => {})
  }, [])

  return (
    <section className="ev-products" id="services">
      <div className="ev-products-container">
        <div className="ev-products-header">
          <div className="ev-products-tag">
            <span>Service Tiers</span>
          </div>
          <h2 className="ev-products-title">
            Choose Your Luxury Experience
          </h2>
        </div>

        <div className="ev-products-grid">
          {serviceTiers.map((tier) => (
            <EVProductCard key={tier.id} serviceTier={tier} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default EVProducts
